<template>
  <Table stripe :columns="columns1"  :data="chapterList" class="table"></Table>
</template>

<script>
  import RequestUtil from '../../../utils/RequestUtil';
  import Constants from '../../../common/Constants';
  export default {
    name: "SelectChapter",
    data(){
      return{
        chapterList:[],
        columns1: [
          {
            title: this.$t('i.SelectChapter.chapter_name'),
            key: 'chapter_name'
          },
          {
            title: this.$t('i.SelectChapter.file_size'),
            key: 'file_size'
          },
          {
            title: this.$t('i.courseware.operation'),
            key:'file_url',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      const serverURL =Constants.serverURL;
                      let Selecturl = params.row.file_url;
                      console.log('Selecturl',Selecturl);
                      window.location = serverURL + Selecturl;
                    }
                  }
                }, '查看')

              ]);
            }
          }
        ],
      }
    },
    methods: {
      async SelectChapter() {
        let Selectid = this.$route.params.id;
        const json = await this.RequestUtil.request("/front/courseware/SelectChapter?Selectid="+Selectid);
        if (json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.chapterList = json.datas.chapterList;
            console.log("预览初始化",this.chapterList);
          }
        }
      },
    },
    mounted () {
      this.SelectChapter();
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/study/components/SelectChapter.vue